import React from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import Download from './Download';
import NoMatch from '../NoMatch';

const LuniuSupplyChain = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/download`}>
        <Download />
      </Route>
      <Route exact path={path}>
        <Redirect to={`${path}/download`} />
      </Route>
      <Route path="*">
        <NoMatch />
      </Route>
    </Switch>
  );
};

export default LuniuSupplyChain;
